const auth = {
  admin: {
    submit: '登录',
    title: 'Avaca AI Hub',
  },
  common: {
    emailLabel: '邮箱地址',
    emailPlaceholder: 'name@company.com',
    hidePassword: '隐藏密码',
    loginError: {
      accountUnavailable: '当前账号不可用，请联系管理员。',
      credentialsInvalid: '邮箱或密码不正确，请检查后重试。',
      emailPasswordDisabled: '当前暂不支持邮箱密码登录，请改用单点登录。',
      generic: '登录失败，请检查信息后重试。',
      serviceUnavailable: '服务暂时不可用，请稍后重试。',
    },
    networkError: '无法连接服务器，请稍后重试。',
    passwordLabel: '密码',
    passwordPlaceholder: '请输入密码',
    passwordResetRequired: '继续前需要先重设密码。',
    showPassword: '显示密码',
    validation: {
      emailInvalid: '请输入有效邮箱',
      emailRequired: '请输入邮箱',
      passwordRequired: '请输入密码',
    },
  },
  language: {
    ariaLabel: '语言',
    english: 'EN',
    simplifiedChinese: '中文',
  },
  passwordReset: {
    backToLogin: '返回登录',
    cancelled: '已退出当前会话',
    confirmPassword: '确认新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    currentPassword: '当前密码',
    currentPasswordPlaceholder: '请输入当前密码',
    errors: {
      submitFailed: '密码更新失败，请检查当前密码后重试。',
    },
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码',
    submit: '更新密码',
    subtitle: '首次登录需先更新密码。',
    successLoginPrompt: '密码已更新，请使用新密码重新登录。',
    title: '更新你的密码',
    validation: {
      confirmPasswordRequired: '请确认新密码',
      currentPasswordRequired: '请输入当前密码',
      newPasswordRequired: '请输入新密码',
      passwordMismatch: '两次输入的密码不一致',
    },
  },
  oauthAuthorization: {
    backToLogin: '返回登录',
    errorDescription: '授权请求无效，或无法恢复 Hub 登录态。',
    errorTitle: '无法继续授权',
    processing: '正在继续授权...',
  },
  ssoCallback: {
    backToLogin: '返回登录',
    errorDescription: '单点登录验证失败，请重新发起登录。',
    errorTitle: 'SSO 登录失败',
    missingCode: '登录回调缺少必要参数，请重新发起登录。',
    processing: '正在完成单点登录...',
    success: 'SSO 登录成功',
  },
  wecomAuth: {
    manualBindingHelp:
      '你可以先登录已有 AI Hub 账号，再确认绑定本次企业微信身份。绑定成功后，下次从工作台进入即可免密登录。',
    authorizeEmail: '授权企业邮箱并绑定账号',
    emailDescription:
      '授权读取企业邮箱，系统将匹配管理员维护的同邮箱 AI Hub 账号，完成绑定并直接登录。',
    restart: '请从企业微信工作台重新打开 AI Hub。',
    confirm: '确认绑定并继续',
    confirmDescription: '请确认将当前 Portal 账号与已验证的企业微信身份绑定。',
    currentAccount: '当前 Portal 账号',
    errorTitle: '企业微信登录未完成',
    errors: {
      configurationIncomplete: '企业微信自动绑定尚未配置完成，请联系管理员完善邮箱绑定设置。',
      authorizationIncomplete: '授权尚未完成，请重新授权。',
      emailMissing: '未能取得邮箱，请联系管理员检查企微权限和成员资料。',
      emailNotAllowed: '该邮箱不在企业允许范围内，请联系管理员。',
      accountNotFound:
        '没有找到与企微邮箱一致的 AI Hub 账号，请联系管理员在组织管理中创建账号或更正邮箱。',
      accountEmailAmbiguous: '多个 AI Hub 账号使用了相同邮箱，请联系管理员修正重复邮箱后重试。',
      notEligible: '登录流程已更新，请关闭此页，从企业微信工作台重新打开 AI Hub。',
      emailChanged:
        'AI Hub 账号邮箱在登录期间发生了变化，请从工作台重新打开应用；若仍失败，请联系管理员核对两边的邮箱。',
      requiresReset: '账号有待处理的改密要求，请先联系管理员处理。',
      identityMismatch: '两次授权的企微账号不一致，请从工作台重新开始。',
      policyChanged: '企业认证配置已更新，请从工作台重新开始。',
      versionConflict: '授权状态已更新，请重试。',
      accountInactive: '账号当前不可用，请联系管理员',
      bindingNotReady: '企业微信连接不可用，请联系管理员',
      conflict: '该企业微信身份已绑定其他账号，请联系管理员',
      expired: '登录已失效，请从工作台重试',
      generic: '企业微信登录未完成，请重试',
      unavailable: '企业微信服务暂时不可用，请稍后重试',
      unbound: '需要登录一次 Portal 账号完成绑定',
    },
    goToLogin: '去登录',
    processing: '正在完成企业微信登录...',
    signedInAccount: '当前已登录账号',
  },
  user: {
    divider: '或继续使用',
    noLoginMethods: '当前没有可用登录方式，请联系管理员。',
    redirectingToSso: '正在前往企业认证...',
    sso: '单点登录 (SSO)',
    submit: '登 录',
    title: 'Avaca AI Hub',
  },
}

export default auth
